import {
    CircleBufferGeometry,
    PlaneBufferGeometry,
    PlaneGeometry,
    TextureLoader,
    MeshBasicMaterial,
    DoubleSide,
    FrontSide,
} from 'three';
import de from '../../../lang/de';


export const meshTextures = {};
export const meshGeometries = {};
export const uvBuffer = {};
export const positionBuffer = {};
export const tileMaterials = {};

// Saved stream dims keyed by stream id
export const savedStreamInfo = {};


export const chairCircleGeometry = new CircleBufferGeometry(40, 64);
export const smallChairCircleGeometry = new CircleBufferGeometry(8, 32);

export const squareGeometry = new PlaneBufferGeometry(48, 48);

export const chairPlaneGeometry = new PlaneGeometry(96, 96);  //double borderCircleGeometry
export const moodCircleGeometry = new CircleBufferGeometry(42, 64);
export const borderCircleGeometry = new CircleBufferGeometry(42, 64);

export const textureToggleGeometry = new CircleBufferGeometry(10, 32);
export const btnGeometry = new CircleBufferGeometry(10, 32);
export const bigBtnGeometry = new CircleBufferGeometry(80, 32);

export const sceneChangeGeometry = squareGeometry;
export const youtubePlaneGeometry = new PlaneGeometry(480, 360);
export const menuPositionCircleGeometry = new CircleBufferGeometry(2, 8);

export const shareScreenGeometry = new PlaneGeometry(480, 360);
export const borderShareScreenGeometry = new PlaneGeometry(485, 362);

export const profileCircleGeometry = chairCircleGeometry;
export const linkGeometry = squareGeometry;
export const chessGeometry = new CircleBufferGeometry(24, 32);;

export const textureLoader = new TextureLoader();
export const green_mood = textureLoader.load('/textures/greenMood.png'); // green_mood.png
export const bagless_logo = textureLoader.load('/textures/bagless_logo.png'); // green_mood.png
export const yellow_mood = textureLoader.load('/textures/yellowMood.png');
export const red_mood = textureLoader.load('/textures/redMood.png');

export const defaultTexture = textureLoader.load('/textures/defaultAvatar.png');
export const inTalkTexture = textureLoader.load('/textures/inTalk.png');
export const emptySeatTexture = textureLoader.load('/textures/emptySeat.png');
export const ai_avatar = textureLoader.load('/textures/AI_avatar.png');

export const screenShareTexture = textureLoader.load('/textures/icons/edit_screenShare.png'); // screenShareBG.png
export const tourModeScreenShareTexture = textureLoader.load('/textures/icons/tour_mode_screen_share.png'); // screenShareBG.png

export const lockedTexture = textureLoader.load('/textures/locked.png');


export const delete_icon = textureLoader.load('/textures/icons/ICON_Delete_Black.png');
export const settings_icon = textureLoader.load('/textures/icons/ICON_Adjustment_Black.png');

export const imageGallery = textureLoader.load('/textures/icons/edit_imageGallery.png');
export const videoPlayer = textureLoader.load('/textures/icons/edit_play_video.png');
export const musicObjectTexture = textureLoader.load('/textures/icons/icon_sound.svg');
export const imageGalleryLoading = textureLoader.load('/textures/bagless_logo_loading.png');
export const linkTexture = textureLoader.load('/textures/icons/edit_link.png');
export const chessTexture = textureLoader.load('/textures/icons/edit_chess_game.png');
export const paypalDonateTexture = textureLoader.load('/textures/icons/edit_donation.png');
export const emptyTexture = textureLoader.load('/textures/empty.png');

/** World-space hit plane for edit-mode 2D indicators (≈64px screen indicator, not the old 48–64 icon mesh). */
export const INDICATOR_HIT_SIZE = 32;
export const infoTexture = textureLoader.load('/textures/icons/info_element.png');
export const baglessRoomLockTexture = textureLoader.load('/textures/icons/bagless_room_lock.png');

export const micTexture = textureLoader.load('/textures/ICON_Talk_Simple_Active_Black.png');
export const cameraTexture = textureLoader.load('/textures/ICON_Video_Black.png');
export const crossedMicTexture = textureLoader.load('/textures/ICON_Talk_Simple_Deactivated_Black.png');
export const mutedMicTexture = textureLoader.load('/textures/icons/icon_mic_off.svg');
export const crossedCameraTexture = textureLoader.load('/textures/ICON_Video_Activation_Simple_Black.png');
export const playIconTexture = textureLoader.load('/textures/playIcon.png');

export const dragTexture = textureLoader.load('/textures/ICON_Drag.png');

export const myLocationTexture = textureLoader.load('/textures/ICON_My_Location.png');

export const borderMaterial = new MeshBasicMaterial({ side: DoubleSide, depthWrite: false, transparent: true, color: 0xffffff, opacity: 0.3 });
export const emptyMaterial = new MeshBasicMaterial({
    color: 0x000000,
    transparent: true,
    opacity: 0
});

export const material1 = new MeshBasicMaterial({
    color: 0x6B9D11,
    // wireframe: true,
    side: DoubleSide,
    transparent: true, // Set to true if you want to adjust opacity
    opacity: 1 // Set your desired opacity (0 = fully transparent, 1 = fully opaque)
});
export const material2 = new MeshBasicMaterial({
    color: 0xDD614A,
    // wireframe: true,
    side: DoubleSide,
    transparent: true, // Set to true if you want to adjust opacity
    opacity: 1 // Set your desired opacity (0 = fully transparent, 1 = fully opaque)
});
export const material3 = new MeshBasicMaterial({
    color: 0xFE9000,
    // wireframe: true,
    side: DoubleSide,
    transparent: true, // Set to true if you want to adjust opacity
    opacity: 1 // Set your desired opacity (0 = fully transparent, 1 = fully opaque)
});
export const materialPrimary = new MeshBasicMaterial({
    color: 0x6B9D11,
    // wireframe: true,
    side: FrontSide,
    depthWrite: false,
    transparent: true, // Set to true if you want to adjust opacity
});

export const materialNegative = new MeshBasicMaterial({
    color: 0xDD614A,
    // wireframe: true,
    side: FrontSide,
    depthWrite: false,
    transparent: true, // Set to true if you want to adjust opacity
});


